export default __webpack_public_path__ + "static/media/event3.b6b72112.png";